<template>
    <div id="mail-integration-detail">
        <div class="route-page-content">
            <SidebarChild
                :items="sidebarItems"
                :selectedItem="currentTab"
                :focusActive="true"
                @selected="handleSidebarSelection"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left-toolbar-content">
                        <IconButton :on-click="() => $router.push('/integrations/mail')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <img :src="logoUrl" />
                        </div>
                        <div class="name">{{ $t("mail.mailDetail") }}: {{ selectedMail ? selectedMail.mail : "" }}</div>
                    </div>
                    <div class="right-toolbar-content">
                        <a-button type="danger" @click="deleteMailAddress()">
                            {{ $t("chatbotv2.delete") }}
                        </a-button>
                    </div>
                </div>
                <div class="page-content">
                    <Integration v-if="currentTab === 'integration'" />
                    <SenderMailAddress v-if="currentTab === 'sender'" />
                    <Signature v-if="currentTab === 'signature'" />
                    <Mails v-if="currentTab === 'inbox'" :selectedMail="selectedMail" />
                    <Medias v-if="currentTab === 'medias'" />
                    <VisibilityChanger v-if="currentTab === 'visibility'" :alertMessage="false" />
                    <MailVisitors v-if="currentTab === 'contacts'" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import IconButton from "../Settings/components/IconButton.vue";
import Integration from "./Detail/EmailIntegration.vue";
import SenderMailAddress from "./Detail/SenderMailAddress.vue";
import Mails from "./Detail/Mails.vue";
import Medias from "./Detail/Medias.vue";
import Signature from "./Detail/Signature.vue";
import VisibilityChanger from "./Detail/VisibilityChanger.vue";
import MailVisitors from "./Detail/MailVisitors.vue";
import { DEFAULT_ORGANIZATION_LOGO_URL } from "../../../utils/staticDatas";
import { sendSocketMessage } from "../../../utils/socketStream";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";

const log = log2("MailIntegrationDetail.vue");
export default Vue.extend({
    name: "MailIntegrationDetail",
    components: {
        MailVisitors,
        VisibilityChanger,
        IconButton,
        Integration,
        Mails,
        Medias,
        Signature,
        SenderMailAddress,
        SidebarChild,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "integration").toLowerCase().trim();
        const pathToKey = {
            integration: "integration",
            sender: "sender",
            signature: "signature",
            inbox: "inbox",
            medias: "medias",
            visibility: "visibility",
            contacts: "contacts",
        };
        return {
            currentTab: pathToKey[path] || "integration",
            selectedId: this.$route.params.id,
            selectedMail: {},
            logoUrl: DEFAULT_ORGANIZATION_LOGO_URL,
            sidebarItems: [],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        isMailUpdatePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.update"].tr.name);
        },
        isMailDeletePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.delete"].tr.name);
        },
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({
            DELETE_MAIL_ADDRESS: "mail/DELETE_MAIL_ADDRESS",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        handleSidebarSelection(item) {
            this.currentTab = item.key;
        },
        deleteMailAddress() {
            if (!this.isMailDeletePermission) {
                this.$message.error(this.$t("noPermission"));
            } else {
                console.log("deleteMailAddress-->", this.selectedMail);
                this.$confirm({
                    title: this.$t("mail.deleteMailTitle"),
                    content: this.$t("mail.deleteMailDesc"),
                    okText: this.$t("chatbotv2.yes"),
                    okType: "danger",
                    cancelText: this.$t("chatbotv2.no"),
                    onOk: () => {
                        sendSocketMessage(
                            this.selectedMail.type === "user"
                                ? "email delete_user_email"
                                : "email delete_department_email",
                            {
                                siteId: this.site._id,
                                mailAddressId: this.selectedMail._id,
                                identity: this.selectedMail.mail,
                            }
                        );
                        this.DELETE_MAIL_ADDRESS(this.selectedMail._id);
                        this.$router.replace("/integrations/mail");
                        this.$message.success(this.$t("message.mailAddressDeletedSucs"));
                    },
                });
            }
        },
    },
    created() {
        this.sidebarItems = [
            {
                key: "integration",
                label: "Entegrasyon Ayarları",
                icon: { type: "material-icons", name: "settings" },
                enabled: true,
                path: "integration",
            },
            {
                key: "sender",
                label: "Gönderici Ayarları",
                icon: { type: "material-icons", name: "send" },
                enabled: true,
                path: "sender",
            },
            {
                key: "signature",
                label: "İmza Ayarları",
                icon: { type: "material-icons", name: "draw" },
                enabled: true,
                path: "signature",
            },
            {
                key: "visibility",
                label: "Görünürlük Ayarları",
                icon: { type: "material-icons", name: "visibility" },
                enabled: true,
                path: "visibility",
            },
            {
                key: "inbox",
                label: "Posta Kutusu",
                icon: { type: "material-icons", name: "inbox" },
                enabled: true,
                path: "inbox",
            },
            {
                key: "medias",
                label: "Medyalar",
                icon: { type: "material-icons", name: "perm_media" },
                enabled: true,
                path: "medias",
            },
            {
                key: "contacts",
                label: "Contacts",
                icon: { type: "material-icons", name: "contacts" },
                enabled: true,
                path: "contacts",
            },
        ];
    },
    mounted() {
        this.selectedMail = this.allMailAddresses.find(
            (email) => email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
        );
    },
    beforeMount() {
        if (!this.isMailUpdatePermission) {
            return this.$router.push("/denied");
        }
    },

    watch: {
        allMailAddresses(value) {
            console.log("mail integration detail allMailAddresses", value);
            this.selectedMail = value.find(
                (email) =>
                    email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
            );
        },
        currentTab(value) {
            const selectedItem = this.sidebarItems.find((item) => item.key === value);
            const path = selectedItem ? selectedItem.path : "integration";
            const type = this.$route.params.type;
            if (path) {
                this.$router.push(`/integrations/mail/${this.selectedId}/${type}/detail/${path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#mail-integration-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .route-page-content {
        display: flex;
        width: 100%;
        height: 100%;
    }

    .page-content-wrapper {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: auto;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border-bottom: 1px solid var(--color-border-default);
            flex-shrink: 0;
            background: var(--color-bg-default);

            .left-toolbar-content {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                }
            }

            .right-toolbar-content {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .page-content {
            height: auto;
            flex-grow: 1;
            overflow: auto;
            position: relative;
            background: var(--color-bg-default);
            padding: 10px;
        }
    }
}
</style>
